import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { LeagueSuspensionsEditorResponse } from "@/types/ApiResponses/League";

export interface GetLeaguesSuspensionsParams {
  lang?: string;
  sportId?: number;
  targetUsername?: string;
}

export const getLeaguesSuspensions = async (
  props: QueryProps<GetLeaguesSuspensionsParams>
): Promise<LeagueSuspensionsEditorResponse> => {
  const res = await api.client.get(`/leagues-new/suspensions`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
